import React from "react";
import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import AgentConfigSection from "../../AgentConfigSection";
import {
  SELF_CONFIGURATION_MODE_AWARENESS_AND_EDIT,
  SELF_CONFIGURATION_MODE_AWARENESS_ONLY,
  SELF_CONFIGURATION_MODE_OFF,
  ensureSelfConfigurationToolsForMode,
  getSelfConfigurationModeHelpText,
  isSelfConfigurationAwarenessEnabled,
  isSelfConfigurationEditEnabled,
} from "../../selfConfiguration";
import { ensureTaskQueuePlannerToolsPaired } from "../../toolCatalog";

export default function SelfConfigurationSection({
  selfConfigurationMode,
  setSelfConfigurationMode,
  setEnabledTools,
}) {
  const applyMode = (nextMode) => {
    setSelfConfigurationMode(nextMode);
    setEnabledTools((prev) =>
      ensureSelfConfigurationToolsForMode(
        ensureTaskQueuePlannerToolsPaired(prev),
        nextMode
      )
    );
  };

  return (
    <AgentConfigSection id="selfConfiguration">
      <Box
        sx={{
          border: "1px solid",
          borderColor: "divider",
          borderRadius: "8px",
          p: 2,
          backgroundColor: "action.hover",
          mb: 2.5,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            gap: 0.5,
          }}
        >
          <FormControlLabel
            sx={{ m: 0, width: "100%", display: "flex" }}
            control={
              <Checkbox
                checked={isSelfConfigurationAwarenessEnabled(
                  selfConfigurationMode
                )}
                onChange={(e) => {
                  const enabled = e.target.checked;
                  applyMode(
                    !enabled
                      ? SELF_CONFIGURATION_MODE_OFF
                      : isSelfConfigurationEditEnabled(selfConfigurationMode)
                      ? SELF_CONFIGURATION_MODE_AWARENESS_AND_EDIT
                      : SELF_CONFIGURATION_MODE_AWARENESS_ONLY
                  );
                }}
              />
            }
            label={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <VisibilityOutlinedIcon
                  sx={{ fontSize: 16, color: "text.secondary" }}
                />
                <Typography sx={{ fontSize: "13px", color: "text.primary" }}>
                  Enable self-configuration awareness
                </Typography>
              </Box>
            }
          />
          <FormControlLabel
            sx={{ m: 0, width: "100%", display: "flex" }}
            control={
              <Checkbox
                checked={isSelfConfigurationEditEnabled(selfConfigurationMode)}
                disabled={
                  !isSelfConfigurationAwarenessEnabled(selfConfigurationMode)
                }
                onChange={(e) => {
                  applyMode(
                    e.target.checked
                      ? SELF_CONFIGURATION_MODE_AWARENESS_AND_EDIT
                      : SELF_CONFIGURATION_MODE_AWARENESS_ONLY
                  );
                }}
              />
            }
            label={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <EditOutlinedIcon
                  sx={{ fontSize: 16, color: "text.secondary" }}
                />
                <Typography sx={{ fontSize: "13px", color: "text.primary" }}>
                  Allow agent to edit its own config
                </Typography>
              </Box>
            }
          />
        </Box>
        <Typography sx={{ fontSize: "11px", color: "text.secondary", mt: 1 }}>
          {getSelfConfigurationModeHelpText(selfConfigurationMode)}
        </Typography>
      </Box>
    </AgentConfigSection>
  );
}
